﻿export interface IUnosData {
    id: number;
    centerId: number;
    dataYear: number;
    deceasedDonorCount: string;
    livingDonorCount: string;
    unosNddCount: string;
    unosKpdCount: string;
    waitListCount: string;
    activeWaitListCount: string;
}

export interface ICenterUnosDataMonthly {
    id: number,
    cId: number,
    cAlias: string,
    date: string,
    dataDate: string,
    ddTxps: string,
    ldTxps: string,
    wlTotal: string,
    wlActive: string,

    lda: string,
    ldb: string,
    ldab: string,
    ldo: string,

    ldra: string,
    ldrb: string,
    ldrab: string,
    ldro: string,
}

export interface ICenterUnosDataMonthlyWithStatus extends ICenterUnosDataMonthly {
    ddTxpsOriginal: string,
    ldTxpsOriginal: string,
    wlTotalOriginal: string,
    wlActiveOriginal: string,

    ldaOriginal: string,
    ldbOriginal: string,
    ldabOriginal: string,
    ldoOriginal: string,

    ldraOriginal: string,
    ldrbOriginal: string,
    ldrabOriginal: string,
    ldroOriginal: string,

    status: number,
    selected: boolean
}